import defaultImage from "@/assets/images/b10img.svg";
import defaultPictogramme from "@/assets/images/b10pictogramme.svg";
import type {SectionPushMaillage} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import {theme} from "@/styles/theme";
import {imageOf} from "@/utils/index";
import PushMailCta from "./PushMailCta";
import {
  ContentWrapper,
  PushMailImage,
  PushMailPictogramme,
  PushMailText,
  PushMailTitle,
  PushMailWrapper,
  TitleWrapper,
} from "./styles";

interface B10PushMailProps {
  sectionData: SectionPushMaillage;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

const B10PushMail = ({
  sectionData,
  isFirstSection,
  isLastSection,
  id,
}: B10PushMailProps) => {
  const {title, title_picto, text, cta_title, cta_target, cta_url, bg_color} =
    sectionData;
  const image = imageOf(sectionData.image);

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <PushMailWrapper aria-label="background image">
        <PushMailImage
          src={image?.url ? image?.url : defaultImage}
          credit={image?.caption}
          alt={image?.alt || "michelin brand image"}
          title={image?.title || "michelin brand image"}
          loading="lazy"
        />
        <ContentWrapper>
          <TitleWrapper>
            {!!title_picto && (
              <PushMailPictogramme
                src={typeof title_picto === "string" ? title_picto : defaultPictogramme}
                alt="picto"
                loading="lazy"
              />
            )}
            <PushMailTitle>{title}</PushMailTitle>
          </TitleWrapper>
          <PushMailText>{text}</PushMailText>
          <PushMailCta
            title={cta_title}
            url={cta_url}
            target={cta_target?.[0]}
            buttonColor={theme?.colors?.brandBlue}
          />
        </ContentWrapper>
      </PushMailWrapper>
    </SectionWrapper>
  );
};

export default B10PushMail;
